import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AgGridRenderersModule } from '@wilson/ag-grid/renderers';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UserQualificationV2 } from '@wilson/interfaces';
import { QualificationNameSyncPipe } from '@wilson/qualification-v2/common';

interface LinkRendererParams extends ICellRendererParams {
  onClick: (event: MouseEvent, data: UserQualificationV2) => void;
}

@Component({
  selector: 'wilson-qualification-link-renderer',
  template: `
    <span (click)="onClick($event)" class="cursor-pointer">
      {{ qualificationName }}
    </span>
  `,
  providers: [QualificationNameSyncPipe],
  imports: [AgGridRenderersModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QualificationLinkRendererComponent
  implements ICellRendererAngularComp
{
  private qualificationNameSyncPipe = inject(QualificationNameSyncPipe);

  params!: LinkRendererParams;
  public qualificationName!: string;

  agInit(params: LinkRendererParams): void {
    this.params = params;
    this.setData(params);
  }

  refresh(params: LinkRendererParams): boolean {
    this.params = params;
    this.setData(params);
    return true;
  }

  onClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.params?.onClick) {
      this.params.onClick(event, this.params.data);
    }
  }

  private setData(params: LinkRendererParams): void {
    this.qualificationName = this.qualificationNameSyncPipe.transform(
      params.data?.qualification,
    );
  }
}
